import { all, put, takeEvery } from 'redux-saga/effects';
import gql from 'graphql-tag';
import { client } from '../apollo';
import { setUserAction } from '../actions/user';
import { loadOperatorAction } from '../actions/session';

function* handleLoadUser() {
    const USER_QUERY = gql`
      query {
        currentUser {
          id
          shortName
          document
          username
          email
          phone
          portalUser {
            operators {
              id
              title
              document
            }
            establishments { id }
            permission
          }
          zwalletUser {
            id
            address {
              id
              zipCode
            }
            isActive
            isEnterprise
            accounts {
              id
              accountNumber
              isActive
              balance
            }
          }
        }
      }
    `;

  try {
    const { data } = yield client.query({
      query: USER_QUERY
    });

    const { currentUser } = data;
    yield put(setUserAction(currentUser));
    yield put(loadOperatorAction());
  
  } catch(error) {
    console.log(error);
  }
}

function * watchLoadtUser() {
    yield takeEvery('LOAD_USER', handleLoadUser);
}

export default function* rootUserSaga() {
    yield all([
        watchLoadtUser()
    ]);
}


// WEBPACK FOOTER //
// ./src/sagas/user.js